export enum OrderStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
}
